module.exports = "/_next/static/images/question_active-92c9ba9cd95faa0783b02adf2264b8d3.svg";